// Nombre de messages non lus, partagé par le menu, la barre mobile et la messagerie (rafraîchi toutes les 20 s).
import { useEffect, useState } from 'react';
import { chatAPI } from '../services/api';

let count = 0;
const subscribers = new Set();
let timer = null;

async function refresh() {
  if (!localStorage.getItem('token')) return;
  try {
    const r = await chatAPI.nonLus();
    count = r.data.non_lus || 0;
    subscribers.forEach((fn) => fn(count));
  } catch { /* hors ligne : on réessaiera */ }
}

/** À appeler après la lecture d'une discussion pour mettre le compteur à jour tout de suite. */
export const refreshChatUnread = () => { refresh(); };

export default function useChatUnread() {
  const [n, setN] = useState(count);
  useEffect(() => {
    subscribers.add(setN);
    if (subscribers.size === 1) {
      refresh();
      timer = setInterval(refresh, 20000);
      window.addEventListener('focus', refresh);
    }
    return () => {
      subscribers.delete(setN);
      if (!subscribers.size) { clearInterval(timer); window.removeEventListener('focus', refresh); }
    };
  }, []);
  return n;
}
